import React, {useContext, useEffect, useState} from "react";
import {GlobalContext} from "../../../../util/state/GlobalContextProvider";
import {useRecoilState} from "recoil";
import {unitsAtom, unitsEnumAtom} from "../../state/rentalPeriodsRecoil";
import {ancillaryTypeAtom, chargingWayAtom, currencyAtom,} from "../../state/constantsRecoil";
import {fromGenericBeToGenericFe, fromSingleGenericBeToSingleGenericFe,} from "../../utils";
import {SET_SNACKBAR} from "../../constants";
import {
    buildEntityRequestFromFormValues,
    buildOWAncillaryExceptionBaseDefinitionValues,
    getOWAncillaryExceptionBaseDefinitionValidationSchema,
    initialOWAncillaryExceptionBaseDefinitionValues,
} from "./BaseDefinition/OWAncillaryExceptionBaseDefinitionForm";
import {useLocation, useParams} from "react-router-dom";
import OWAncillaryExceptionBaseDefinition from "./BaseDefinition/OWAncillaryExceptionBaseDefinition";
import DialogComponent from "../../common/components/DialogComponent";
import {setSnackbar} from "../../../../util/state/globalAction";
import {snackbarTypes} from "../../../../util/state/globalVariables";
import {useConstantsRepository} from "../../api/repositories/ConstantsRepository";
import {useTpUnitRepository} from "../../api/repositories/TpUnitRepository";
import {useCommercialCategoryRepository} from "../../api/repositories/CommercialCategoryRepository";
import Loading from "../../common/components/Loading";
import {Box, Grid, Tab, Tabs} from "@mui/material";
import {useTranslation} from "react-i18next";
import {DialogInterface, SelectElementModelFE, UseLocationStateModel,} from "../../api/types/generic";
import {commercialCategoryListAtom} from "../../state/commercialCategoriesRecoil";
import {yupResolver} from "@hookform/resolvers/yup/dist/yup";
import {FormProvider, useForm} from "react-hook-form";
import {useCommercialSegmentRepository} from "../../api/repositories/CommercialSegmentRepository";
import {commercialSegmentListAtom} from "../../state/commercialSegmentsAtom";
import {CommercialCategoryEntityResponse, CommercialCategorySelectFE,} from "../../api/types/commercialCategory";
import OWRouteExceptionMatrix from "./Matrix/OWRouteExceptionMatrix";
import {
    OWAncillaryExceptionBaseDefinitionFormValues,
    OWAncillaryExceptionEntityRequest,
    OWAncillaryExceptionEntityResponse,
} from "../../api/types/owAncillaryException";
import {useOWAncillaryExceptionRepository} from "../../api/repositories/OWAncillaryExceptionRepository";
import {RouteParams} from "../../api/types/ancillary";
import {ancillaryServiceItem} from "../../state/ancillariesRecoil";
import {useAncillaryRepository} from "../../api/repositories/AncillaryRepository";

type TabPanelProps = {
    children?: React.ReactNode;
    index: number;
    value: number;
};

function TabPanel(props: TabPanelProps) {
    const {children, value, index, ...other} = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {value === index && <Box sx={{p: 3}}>{children}</Box>}
        </div>
    );
}

const OWAncillaryExceptionContent = ({
                                         readOnly,
                                         owAncillaryExceptionId,
                                     }: {
    readOnly: boolean;
    owAncillaryExceptionId?: number;
}) => {
    // Use Translation
    const {t} = useTranslation(["translation", "pricing"]);

    const {id} = useParams<RouteParams>();

    // Use Location
    const location = useLocation();

    const locationState: UseLocationStateModel =
        location.state as UseLocationStateModel;

    // Use Recoil
    const [, setCommercialCategoryList] = useRecoilState(
        commercialCategoryListAtom
    );
    const [, setCommercialSegmentList] = useRecoilState(
        commercialSegmentListAtom
    );
    const [, setUnits] = useRecoilState(unitsAtom);
    const [, setUnitsEnum] = useRecoilState<string[]>(unitsEnumAtom);
    const [, setCurrencies] = useRecoilState(currencyAtom);
    const [, setChargingWays] = useRecoilState(chargingWayAtom);
    const [, setAncillaryTypes] = useRecoilState(ancillaryTypeAtom);
    const [serviceItem, setServiceItem] = useRecoilState<any>(ancillaryServiceItem)


    // Use State
    const [owAncillaryException, setOWAncillaryException] =
        useState<OWAncillaryExceptionEntityResponse | null>(null);
    const [originalCommercialSegment, setOriginalCommercialSegment] =
        useState<SelectElementModelFE | null>(null);
    const [
        owAncillaryExceptionBaseDefinitionValues,
        setOWAncillaryExceptionBaseDefinitionValues,
    ] = useState<OWAncillaryExceptionBaseDefinitionFormValues | null>(null);
    const [
        originalOWAncillaryExceptionBaseDefinitionValues,
        setOriginalOWAncillaryExceptionBaseDefinitionValues,
    ] = useState<OWAncillaryExceptionBaseDefinitionFormValues | null>(null);
    const [value, setValue] = useState<number>(0);
    const [dialog, setDialog] = useState<DialogInterface | null>(null);
    const [owAncillaryExceptionInUse, setOWAncillaryExceptionInUse] =
        useState<boolean>(false);

    // Use Context
    const {dispatchGlobalData} = useContext(GlobalContext);

    // Use Repository Hooks
    const {
        getOWAncillaryException,
        getOWAncillaryExceptionInUse,
        putOWAncillaryException,
        postOWAncillaryException,
    } = useOWAncillaryExceptionRepository();
    const {getCurrencies, getChargingWays, getTypes} = useConstantsRepository();
    const {getTpUnits} = useTpUnitRepository();
    const {getTpUnitsEnum} = useConstantsRepository();
    const {getCommercialCategories} = useCommercialCategoryRepository();
    const {getCommercialSegments} = useCommercialSegmentRepository();
    const {getServiceItem} = useAncillaryRepository();

    const handleSubmit = () => {
        const values: OWAncillaryExceptionBaseDefinitionFormValues =
            form.getValues();
        console.log(values);

        const owAncillaryEntityRequest: OWAncillaryExceptionEntityRequest =
            buildEntityRequestFromFormValues(values, owAncillaryExceptionInUse);
        let notDateFieldsAreUpdated;
        // UPDATE ANCILLARY BASE
        if (
            originalOWAncillaryExceptionBaseDefinitionValues &&
            owAncillaryExceptionBaseDefinitionValues?.id
        ) {
            const updateOWAncillary: OWAncillaryExceptionEntityResponse = {
                id: owAncillaryExceptionBaseDefinitionValues?.id,
                ...owAncillaryEntityRequest,
            };
            if (owAncillaryException) {
                notDateFieldsAreUpdated = checkValues(
                    {
                        ...owAncillaryException,
                    },
                    updateOWAncillary
                );
            }
        }

        setDialog({
            open: true,
            message: owAncillaryExceptionBaseDefinitionValues?.id
                ? owAncillaryExceptionInUse && notDateFieldsAreUpdated
                    ? t("pricing:ancillaryException.banner")
                    : t(
                        "pricing:ancillaryException.dialogContents.updateAncillaryExceptionBase"
                    )
                : t(
                    "pricing:ancillaryException.dialogContents.createAncillaryExceptionBase"
                ),
            onClickConfirm: () => submit(values, owAncillaryEntityRequest),
        });
    };

    // Use Form
    const form = useForm<OWAncillaryExceptionBaseDefinitionFormValues>({
        defaultValues:
            owAncillaryExceptionBaseDefinitionValues ||
            initialOWAncillaryExceptionBaseDefinitionValues,
        resolver: yupResolver(
            getOWAncillaryExceptionBaseDefinitionValidationSchema(
                t,
                owAncillaryException
            ),
            {},
            {
                rawValues: true,
            }
        ),
        shouldUnregister: false,
    });

    const checkValues = (
        originalOWAncillaryExceptionBaseDefinitionValues: OWAncillaryExceptionEntityResponse,
        owAncillaryExceptionBaseDefinitionValues: OWAncillaryExceptionEntityResponse
    ): boolean => {
        //converti in stringa, assegna a oggetto x non perderli, togliere date da oggetto nuovo, stringare,  confrontare stringhe senza date
        const firstStringOriginalOWAncillary = JSON.stringify(
            originalOWAncillaryExceptionBaseDefinitionValues
        );
        const firstStringOWAncillary = JSON.stringify(
            owAncillaryExceptionBaseDefinitionValues
        );

        const objectOriginalOWAncillary = JSON.parse(
            firstStringOriginalOWAncillary
        );
        const objectOWAncillary = JSON.parse(firstStringOWAncillary);

        delete objectOriginalOWAncillary.pickupFrom;
        delete objectOriginalOWAncillary.pickupTo;
        delete objectOriginalOWAncillary.reservationFrom;
        delete objectOriginalOWAncillary.reservationTo;

        delete objectOWAncillary.pickupFrom;
        delete objectOWAncillary.pickupTo;
        delete objectOWAncillary.reservationFrom;
        delete objectOWAncillary.reservationTo;

        const updatedStringOriginalOWAncillary = JSON.stringify(
            Object.entries(objectOriginalOWAncillary).sort()
        );
        const updatedStringOWAncillary = JSON.stringify(
            Object.entries(objectOWAncillary).sort()
        );

        return updatedStringOriginalOWAncillary !== updatedStringOWAncillary;
    };

    const submit = async (
        values: OWAncillaryExceptionBaseDefinitionFormValues,
        owAncillaryEntityRequest: OWAncillaryExceptionEntityRequest
    ) => {
        const owAncillaryException: OWAncillaryExceptionEntityRequest =
            owAncillaryEntityRequest;

        try {
            if (owAncillaryException.prcAncillary !== null) {
                owAncillaryException.prcAncillary.taxCode = serviceItem.find(
                    (item: any) => item.name === owAncillaryException.prcAncillary?.taxCode
                )?.code || owAncillaryException.prcAncillary.taxCode;
            }

            owAncillaryException.taxCode = serviceItem.find(
                (item: any) => item.name === owAncillaryException.taxCode
            )?.code || owAncillaryException.taxCode;

            const persistedOWAncillaryException =
                owAncillaryExceptionBaseDefinitionValues?.id
                    ? await putOWAncillaryException({
                        id: owAncillaryExceptionBaseDefinitionValues?.id,
                        ...owAncillaryException,
                    })
                    : await postOWAncillaryException(owAncillaryException);
            const commercialCategory: CommercialCategorySelectFE | undefined =
                fromSingleGenericBeToSingleGenericFe(
                    owAncillaryException.commercialCategory
                ) as CommercialCategorySelectFE;
            const commercialSegment: SelectElementModelFE | undefined =
                fromSingleGenericBeToSingleGenericFe(
                    commercialCategory?.commercialSegment
                );

            form.reset();
            dispatchGlobalData(SET_SNACKBAR.SUCCESS);
            const currentOWAncillaryExceptionBaseDefinitionValues: OWAncillaryExceptionBaseDefinitionFormValues =
                buildOWAncillaryExceptionBaseDefinitionValues(
                    persistedOWAncillaryException, serviceItem,
                    t
                );
            setOWAncillaryExceptionBaseDefinitionValues(
                currentOWAncillaryExceptionBaseDefinitionValues
            );
            setOWAncillaryException(persistedOWAncillaryException);
            setOriginalCommercialSegment(commercialSegment);
            form.reset(currentOWAncillaryExceptionBaseDefinitionValues);

            setDialog(null);
            setValue(1);
        } catch (e) {
        }
    };

    const getStaticContents = async () => {
        try {
            // TODO: togliere COMMERCIAL_CATEGORIES || quando si pusha
            // const commercialCategoriesData: CommercialCategoryEntityResponse[] = COMMERCIAL_CATEGORIES || await getCommercialCategories();
            const commercialCategoriesData: CommercialCategoryEntityResponse[] =
                await getCommercialCategories();

            const tpUnitsData = await getTpUnitsEnum();
            const currenciesData = await getCurrencies();
            const chargingWaysData = await getChargingWays();
            const typesData = await getTypes();

            // TODO: togliere COMMERCIAL_SEGMENTS || quando si pusha
            // const commercialSegmentsData = COMMERCIAL_SEGMENTS || await getCommercialSegments();
            const commercialSegmentsData = await getCommercialSegments();

            const commercialCategoryList: CommercialCategorySelectFE[] =
                fromGenericBeToGenericFe(commercialCategoriesData);
            // Non settiamo il Recoil atom qui - il BaseDefinition lo gestirà con filtraggio per labels
            // setCommercialCategoryList(commercialCategoryList);

            setUnitsEnum(tpUnitsData);

            const commercialSegmentList: SelectElementModelFE[] =
                fromGenericBeToGenericFe(commercialSegmentsData);
            setCommercialSegmentList(commercialSegmentList);

            setCurrencies(currenciesData);
            setChargingWays(chargingWaysData);
            setAncillaryTypes(typesData);

            if ((locationState?.owAncillaryExceptionId || id || owAncillaryExceptionId) && !owAncillaryExceptionBaseDefinitionValues?.id) {

                const owAncillaryException = await getOWAncillaryException((id || locationState?.owAncillaryExceptionId || owAncillaryExceptionId) as number);

                const commercialCategory: CommercialCategorySelectFE | undefined = fromSingleGenericBeToSingleGenericFe(owAncillaryException.commercialCategory) as CommercialCategorySelectFE;
                const commercialSegment: SelectElementModelFE | undefined = fromSingleGenericBeToSingleGenericFe(commercialCategory?.commercialSegment);
                const services = await getServiceItem(owAncillaryException.legalEntity, owAncillaryException.dealer);
                setServiceItem(services);

                if (owAncillaryException) {
                    const owAncillaryExceptionBaseDefinitionValues: OWAncillaryExceptionBaseDefinitionFormValues =
                        buildOWAncillaryExceptionBaseDefinitionValues(owAncillaryException, services, t);
                    setOWAncillaryException(owAncillaryException);
                    setOriginalCommercialSegment(commercialSegment);
                    form.reset(owAncillaryExceptionBaseDefinitionValues);
                    setOWAncillaryExceptionBaseDefinitionValues(
                        owAncillaryExceptionBaseDefinitionValues
                    );
                    const originalOWAncillaryExceptionBaseDefinitionValues: OWAncillaryExceptionBaseDefinitionFormValues =
                        JSON.parse(
                            JSON.stringify(owAncillaryExceptionBaseDefinitionValues)
                        );

                    setOriginalOWAncillaryExceptionBaseDefinitionValues(
                        originalOWAncillaryExceptionBaseDefinitionValues
                    );
                }
            }
        } catch (e) {
        }
    };

    // Use Effect
    useEffect(() => {
        getStaticContents();
        // eslint-disable-next-line
    }, []);

    useEffect(() => {
        if (owAncillaryExceptionBaseDefinitionValues?.id) {
            reloadOWAncillaryExceptionInUse();
        }
        // eslint-disable-next-line
    }, [owAncillaryExceptionBaseDefinitionValues?.id]);

    const reloadOWAncillaryExceptionInUse = async () => {
        try {
            if (owAncillaryExceptionBaseDefinitionValues?.id) {
                const owAncillaryExceptionInUse = await getOWAncillaryExceptionInUse(
                    owAncillaryExceptionBaseDefinitionValues.id
                );
                setOWAncillaryExceptionInUse(owAncillaryExceptionInUse);
            }
        } catch (e) {
            console.log(e);
        }
    };

    const handleChange = (event: React.SyntheticEvent, newValue: number) => {
        // click su matrice dei prezzi ma ancillaryException non ancora creata
        if (
            newValue === 1 &&
            !owAncillaryExceptionBaseDefinitionValues?.id &&
            !readOnly
        ) {
            dispatchGlobalData({
                type: setSnackbar,
                payload: {
                    snackbar: {
                        message: t(
                            "pricing:ancillaryException.dialogContents.createAncillaryExceptionMatrix"
                        ),
                        type: snackbarTypes.warning,
                        show: true,
                        autoClose: true,
                    },
                },
            });
        } else if (newValue === 0 && !readOnly) {
            setDialog({
                open: true,
                message: t("pricing:dialogs.messages.looseChanging"),
                onClickConfirm: () => {
                    setDialog(null);
                    setValue(newValue);
                },
            });
        }
        // click su ancillaryException
        else {
            setValue(newValue);
        }
    };

    return (
        <Grid sx={{padding: 0}}>
            <Box sx={{borderBottom: 1, borderColor: "divider"}}>
                <Tabs
                    value={value}
                    onChange={handleChange}
                    aria-label="basic tabs example"
                >
                    <Tab
                        label={t(
                            "pricing:ancillaryExceptionCreate.titles.ancillaryExceptionCreate"
                        )}
                    />
                    <Tab
                        label={t(
                            "pricing:ancillaryExceptionCreate.titles.ancillaryExceptionMatrix"
                        )}
                    />
                </Tabs>
            </Box>
            <TabPanel value={value} index={0}>
                <FormProvider {...form}>
                    <OWAncillaryExceptionBaseDefinition
                        originalCommercialSegment={originalCommercialSegment}
                        owAncillaryExceptionInUse={owAncillaryExceptionInUse}
                        readOnly={readOnly}
                        handleSubmit={form.handleSubmit(handleSubmit)}
                        owAncillaryExceptionId={owAncillaryExceptionId}
                    />
                </FormProvider>
            </TabPanel>
            <TabPanel value={value} index={1}>
                <OWRouteExceptionMatrix
                    owAncillaryExceptionId={
                        owAncillaryExceptionId ||
                        locationState?.owAncillaryExceptionId ||
                        owAncillaryExceptionBaseDefinitionValues?.id ||
                        null
                    }
                    owAncillaryExceptionInUse={owAncillaryExceptionInUse}
                    readOnly={readOnly}
                    setValue={setValue}
                />
            </TabPanel>
            {dialog?.open && (
                <DialogComponent
                    type={"info"}
                    onClickConfirm={dialog.onClickConfirm}
                    setOpen={() => setDialog(null)}
                    open={dialog.open}
                    message={dialog.message}
                />
            )}
            <Loading/>
        </Grid>
    );
};

export default OWAncillaryExceptionContent;
